import React from "react";
import { useSelector } from "react-redux";

import type { NoteDetail } from "@/core/types";
import { selectProfile } from "@/redux/selectors/authSelectors";

import { useNoteAddendums } from "../api/queries/useNoteAddendums";

import { NoteAddendum } from "./NoteAddendum";

type AddendumsSectionProps = {
  note: NoteDetail;
};

export function Addendums({ note }: AddendumsSectionProps) {
  const { id: noteId, patient_id: patientId } = note;

  const profile = useSelector(selectProfile);
  const { data: addendums = [], refetch } = useNoteAddendums({ noteId, patientId });

  const isAddendumDisabled = !!note.is_cosign_required;

  const canAddNewAddendum =
    note.created_by === profile?.username &&
    note.signature &&
    note.note_state !== "draft" &&
    note.note_state !== "pending" &&
    note.note_type !== "Advanced Care Activity" &&
    (addendums?.length ?? 0) < 5;

  return (
    <>
      {note.note_state !== "draft" &&
        addendums?.map((addendum, index) => (
          <NoteAddendum
            credentials={addendum.credentials}
            data={addendum.addendum}
            key={addendum.addendum_id ?? index}
            noteId={noteId}
            onSubmit={() => {}}
            patientId={patientId}
            signature={addendum.signature}
            textTestId={`note-addendum-text-${index}`}
            timestamp={addendum.timestamp}
          />
        ))}

      {canAddNewAddendum && (
        <NoteAddendum
          credentials={note.provider_cp_credentials}
          data={undefined}
          isDisabled={isAddendumDisabled}
          noteId={noteId}
          onSubmit={() => {
            void refetch();
          }}
          patientId={patientId}
          signature={note.signature}
          textTestId={undefined}
          timestamp={undefined}
        />
      )}
    </>
  );
}
